import React from "react";
import TextField from "@mui/material/TextField";
import { useField } from "formik";



export const Textarea = ({ name, rows, ...props }) => {
  const [field, meta] = useField(name);
  return (
      <TextField
          rows={rows ?? 4}
          label={props.label || name}
          fullWidth={props.fullWidth ?? true}
          margin="normal"
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          {...field}
          {...props}
      />
  );
}

export default Textarea;
